import { useState } from 'react'
import { useLingui } from '@lingui/react/macro'

import Button from '@/components/ui/Button'
import ConfirmDialog from '@/components/ui/ConfirmDialog'

export function EnableNotificationsButton() {
  const { t } = useLingui()
  const [permission, setPermission] = useState(Notification.permission)

  const handleConfirm = async () => {
    const result = await Notification.requestPermission()
    setPermission(result)
  }

  if (permission === 'granted') return null

  if (permission === 'denied')
    return (
      <Button
        disabled
      >{t`Notifications are blocked in your browser settings.`}</Button>
    )

  return (
    <ConfirmDialog
      isOpen={permission === 'default'}
      title={t`Stay informed`}
      message={t`We'd like to notify you about new order requests, even when you're on another tab. After clicking "Allow notifications", the browser should aks for your permission in a separate pop-up.`}
      confirm={t`Allow notifications`}
      onConfirm={handleConfirm}
      asChild
    >
      <Button>{t`Enable notifications`}</Button>
    </ConfirmDialog>
  )
}
